module.exports = __webpack_public_path__ + "img/manage-rs-nodata.7a4b0f7e.svg";